import {
  BulkOneClickPrintBatchLimit,
  BulkOneClickPrintOrderLimit,
} from "@redotech/redo-fulfillment-common/bulk-shipment-print";
import * as z from "zod";

export const BulkOneClickPrintBatchSchema = z.object({
  batchKey: z.string(),
  itemCount: z.number().int().nonnegative(),
  orderCount: z.number().int().positive().max(BulkOneClickPrintOrderLimit),
});

export const BulkOneClickPrintBatchesSchema = z
  .array(BulkOneClickPrintBatchSchema)
  .min(1)
  .max(BulkOneClickPrintBatchLimit)
  .superRefine((batches, ctx) => {
    const batchKeys = new Set(batches.map((batch) => batch.batchKey));
    if (batchKeys.size !== batches.length) {
      ctx.addIssue({
        code: "custom",
        message: "Bulk one-click print batch keys must be unique",
      });
    }

    const orderCount = batches.reduce(
      (total, batch) => total + batch.orderCount,
      0,
    );
    if (orderCount > BulkOneClickPrintOrderLimit) {
      ctx.addIssue({
        code: "custom",
        message: `Bulk one-click print is limited to ${BulkOneClickPrintOrderLimit} orders`,
      });
    }
  });

export const getBulkOneClickPrintSummary = {
  name: "getBulkOneClickPrintSummary" as const,
  input: z.null(),
  output: z.object({
    batches: z
      .array(BulkOneClickPrintBatchSchema)
      .max(BulkOneClickPrintBatchLimit),
    hasMore: z.boolean(),
  }),
};
